import { render, staticRenderFns } from "./MessageSingle.vue?vue&type=template&id=e546247a&scoped=true"
import script from "./MessageSingle.vue?vue&type=script&lang=js"
export * from "./MessageSingle.vue?vue&type=script&lang=js"
import style0 from "./MessageSingle.vue?vue&type=style&index=0&id=e546247a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e546247a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Avatar: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/Avatar.vue').default})
